import React from 'react';
import { Navigate } from 'react-router-dom';
import EdizioneService from '../../api/edizioneService';

/**
 * Le pagine del torneo (accettazione, formula, planning, partite, ...) esistono solo dentro
 * un'edizione: senza edizione scelta non hanno niente da mostrare, e restare li' significa
 * leggere "Nessuna edizione selezionata" e dover tornare indietro a mano. Si passa prima dalla
 * scelta del torneo.
 */
const EdizioneRoute = ({ children }) => {
  if (!EdizioneService.get()) {
    return <Navigate to="/admin/tornei" replace />;
  }

  return children;
};

export default EdizioneRoute;
